<script setup>
import CFIcon from '@/ui/Icon/CFIcon.vue';

defineProps({
    file: {
        type: Object,
        required: true,
    },
});

const emit = defineEmits(['remove']);
</script>

<template>
    <div class="flex items-center justify-between gap-4 py-4 pr-4">
        <span>{{ file.name }}</span>
        <button
            type="button"
            @click="emit('remove')"
        >
            <CFIcon
                name="close"
                class="size-4 text-red-600"
            />
        </button>
    </div>
</template>
